export default function ErrorFallback() {
  return (
    <div className="w-screen h-screen flex flex-col items-center justify-center bg-muted/50">
      <h1 className="text-2xl font-bold text-foreground/80 mb-4">
        Something went wrong
      </h1>
      <p className="text-muted-foreground mb-6">
        We’re working on it. Please try again in a moment.
      </p>
      <button
        onClick={() => window.location.reload()}
        className="px-5 py-2 bg-primary text-primary-foreground hover:bg-primary/90 rounded-lg"
      >
        Reload Page
      </button>
    </div>
  );
}
